import { Link } from 'react-router-dom';
import { cn } from '@adop/ui';

/**
 * The adop wordmark + logo, used in the marketplace header and the dashboard top
 * bar. The image is a static asset in apps/platform/public/logo.png.
 */
export function Brand({
  to = '/',
  className,
  showWordmark = true,
}: {
  to?: string;
  className?: string;
  showWordmark?: boolean;
}) {
  return (
    <Link
      to={to}
      aria-label="adop home"
      className={cn(
        'inline-flex items-center gap-2 text-lg font-bold tracking-tight text-zinc-900',
        className,
      )}
    >
      <img src="/logo.png" alt="" className="h-7 w-7 rounded-md object-contain" />
      {showWordmark ? <span>adop</span> : null}
    </Link>
  );
}
